import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Offer } from '../_models/offer';

@Injectable({ providedIn: 'root' })
export class OfferService {
    constructor(
        private router: Router,
        private http: HttpClient
    ) {}

    list(type = 'list'): any {
    	let filters = {
    	  type: type == "list" ? "list" : "slider" 
    	};
    	return this.http.get<Offer[]>(`${environment.apibase}offers`, { params: filters });
    }
    
    single(id: any): any {
    	return this.http.get<Offer[]>(`${environment.apibase}offer/${id}`);
    }
}